var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrpdwicon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0865 8.47051L19.3629 0.0123291H17.6386L11.3205 7.35644L6.27431 0.0123291H0.454102L8.08497 11.1179L0.454102 19.9876H2.17846L8.8505 12.232L14.1797 19.9876H19.9999L12.0861 8.47051H12.0865ZM9.72475 11.2158L8.95158 10.1099L2.79977 1.3104H5.44829L10.4129 8.41188L11.186 9.51775L17.6394 18.7486H14.9909L9.72475 11.2162V11.2158Z",
    fill: "#E6A358"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrpdwicon4);
export default __webpack_public_path__ + "static/media/drpdwicon4.8448e67e3456fa5897d836c3cfa07083.svg";
export { ForwardRef as ReactComponent };